import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { bool, string, number } from 'prop-types';
import './LoadingProgressTransition.scss';

export default class LoadingProgressTransition extends PureComponent {
    static propTypes = {
        starting: bool,
        finishing: bool,
        classNames: string,
        timeToActiveEaseIn: number,
    };

    static defaultProps = {
        starting: false,
        finishing: false,
        timeToActiveEaseIn: 350,
        classNames: '',
    };

    componentDidMount() {
        this.startingTime = this.props.starting ? Date.now() : 0;
    }

    componentDidUpdate(prevProps) {
        const { starting, finishing } = this.props;

        if (!prevProps.starting && !finishing && starting) {
            this.startingTime = Date.now();
        } else if (
            prevProps.starting &&
            !prevProps.finishing &&
            !starting &&
            finishing
        ) {
            this.startingTime = 0;
        }
    }

    /**
     * Determine if the finishing transition should be eased-in or not depending on
     * timeToActiveEaseIn in props. (when not set, timeToActiveEaseIn = 350)
     * @returns {boolean}
     */
    isEasedTransition() {
        return Date.now() - this.startingTime > this.props.timeToActiveEaseIn;
    }

    render() {
        const { starting, finishing, classNames } = this.props;

        const rootClassnames = classnames('loading-progress', classNames, {
            'loading-progress--starting': starting,
            'loading-progress--finishing': finishing,
            'loading-progress--finishing--ease-in':
                finishing && this.isEasedTransition(),
        });

        return <div className={rootClassnames} />;
    }
}
